import {
  animate,
  AnimationBuilder,
  AnimationFactory,
  style,
} from '@angular/animations';
import { Platform } from '@angular/cdk/platform';
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appSlideRight]',
})
export class SlideRightDirective implements AfterViewInit {
  @Input() slideRightDuration: number = 500; // 默认动画时长 (ms)
  @Input() slideRightDelay: number = 0; // 默认延迟 (ms)
  @Input() slideRightX: number = -20;
  @Input() onIntersection: boolean = false;

  opacity: number = 1;
  constructor(
    private el: ElementRef,
    private animationBuilder: AnimationBuilder,
    private platform: Platform
  ) {
    this.opacity = this.el.nativeElement.style.opacity;
    this.el.nativeElement.style.opacity = 0;
  }

  ngAfterViewInit(): void {
    if (!this.platform.isBrowser) {
      return;
    }
    if (this.onIntersection) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target); // Stop observing once the animation has been triggered
            this.applyAnimation();
          }
        });
      });

      observer.observe(this.el.nativeElement); // Target the element you want to animate
    } else {
      this.applyAnimation();
    }
  }

  private applyAnimation(): void {
    // 定义动画
    const animation: AnimationFactory = this.animationBuilder.build([
      style({ opacity: 0, transform: `translateX(${this.slideRightX}px)` }),
      animate(
        `${this.slideRightDuration}ms ${this.slideRightDelay}ms ease-in-out`,
        style({ opacity: 1, transform: 'translateX(0px)' })
      ),
    ]);

    // 创建动画播放器并应用到元素上
    const player = animation.create(this.el.nativeElement);
    player.onDone(() => {
      this.el.nativeElement.style.opacity = this.opacity;
    });
    player.play();
  }
}
